import styled from 'styled-components';

export const Container = styled.div`
  width: ${({ theme }) => theme.spacing[96]};
`;
